(function () {
  var hist = window.__hoHist || (window.__hoHist = { n: 0, fns: [] });
  var HO_MENU_CFG = window.HO_MENU_CFG || {};
  /* ================================================== Favorites store */
  var KEY = 'hoFav';
  function read() { try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function write(v) { try { localStorage.setItem(KEY, JSON.stringify(v.slice(0, 100))); } catch (e) {} }
  var HoFav = {
    list: read,
    has: function (h) { return read().indexOf(h) >= 0; },
    count: function () { return read().length; },
    toggle: function (h) {
      var v = read(), i = v.indexOf(h), on;
      if (i >= 0) { v.splice(i, 1); on = false; } else { v.unshift(h); on = true; }
      write(v);
      document.dispatchEvent(new CustomEvent('hofav:change', { detail: { handle: h, on: on } }));
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(on ? 'ho_fav_add' : 'ho_fav_remove', { handle: h }); } catch (e) {}
      return on;
    },
    remove: function (h) { if (HoFav.has(h)) HoFav.toggle(h); }
  };
  window.HoFav = HoFav;

  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.2-9.4C1.6 7.7 3.8 4.5 7.1 4.5c2 0 3.6 1.1 4.9 2.9 1.3-1.8 2.9-2.9 4.9-2.9 3.3 0 5.5 3.2 4.3 6.6-1.7 4.8-9.2 9.4-9.2 9.4z"/></svg>';
  function handleFrom(href) { var m = String(href || '').match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : null; }

  /* Page speed: `list` lets syncAll read the saved favorites once for every
     heart instead of once per heart, and attributes are only written when
     they change, so repainting the hearts does not make the browser redo
     page styles. Same result on screen. */
  function paint(btn, list) {
    var on = (list || read()).indexOf(btn.getAttribute('data-hofav')) >= 0;
    var pressed = on ? 'true' : 'false';
    var label = on ? 'Remove from favorites' : 'Save to favorites';
    if (btn.classList.contains('is-on') !== on) btn.classList.toggle('is-on', on);
    if (btn.getAttribute('aria-pressed') !== pressed) btn.setAttribute('aria-pressed', pressed);
    if (btn.getAttribute('aria-label') !== label) btn.setAttribute('aria-label', label);
  }
  function makeBtn(h, extra, list) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'hofav-btn' + (extra ? ' ' + extra : '');
    b.setAttribute('data-hofav', h);
    b.innerHTML = HEART;
    paint(b, list);
    return b;
  }

  /* Hearts on product cards, including cards added later (filters, load more).
     Page speed: all cards are measured first and the hearts added after.
     Measuring one card, adding its heart, then measuring the next made the
     browser recalculate the whole page's styles once per card (about 80 on
     the home page, a long freeze on a phone). */
  function decorate(scope) {
    var todo = [];
    (scope || document).querySelectorAll('.product-grid-item').forEach(function (card) {
      if (card.__hofav) return;
      var link = card.querySelector('a[href*="/products/"]');
      var holder = card.querySelector('.product-grid-item__image') || card;
      var h = link && handleFrom(link.getAttribute('href'));
      if (!h) return;
      card.__hofav = true;
      todo.push([holder, h]);
    });
    if (!todo.length) return;
    var statics = todo.map(function (it) { return getComputedStyle(it[0]).position === 'static'; });
    var list = read();
    todo.forEach(function (it, i) {
      if (statics[i]) it[0].style.position = 'relative';
      it[0].appendChild(makeBtn(it[1], '', list));
    });
  }
  /* Heart beside the title on the product page. */
  function decorateProduct() {
    var title = document.querySelector('h1.product__title');
    var h = handleFrom(location.pathname);
    if (!title || !h || title.parentNode.querySelector('.hofav-btn')) return;
    /* Carousel gallery with thumbnails: ho-gallery-base puts the heart on the
       main photo and removes this inline one again, so adding it here only
       made the title wrap and unwrap while the page loaded (layout shift). */
    if (document.querySelector('[data-section-type="product-template"] .product-single__wrapper--carousel [data-product-single-media-thumbs]')) return;
    var row = document.createElement('div');
    row.className = 'hofav-title-row';
    title.parentNode.insertBefore(row, title);
    row.appendChild(title);
    row.appendChild(makeBtn(h, 'hofav-btn--inline'));
  }

  var toast, toastTimer;
  function showToast(on) {
    if (!toast) { toast = document.createElement('div'); toast.className = 'hofav-toast'; toast.setAttribute('role', 'status'); document.body.appendChild(toast); }
    toast.innerHTML = on ? 'Saved to favorites <a href="' + HO_MENU_CFG.favUrl + '">View</a>' : 'Removed from favorites';
    toast.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 2400);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.hofav-btn');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var on = HoFav.toggle(b.getAttribute('data-hofav'));
    b.classList.remove('is-pop'); void b.offsetWidth; if (on) b.classList.add('is-pop');
    showToast(on);
  }, true);

  function syncAll() {
    var list = read();
    document.querySelectorAll('.hofav-btn').forEach(function (b) { paint(b, list); });
    var n = list.length;
    document.querySelectorAll('[data-hofav-count]').forEach(function (el) {
      if (el.textContent !== String(n)) el.textContent = n;
      if (el.hidden !== (n === 0)) el.hidden = n === 0;
    });
  }
  document.addEventListener('hofav:change', syncAll);
  window.addEventListener('storage', function (e) { if (e.key === KEY) syncAll(); });

  function start() {
    decorate(); decorateProduct(); syncAll();
    if ('MutationObserver' in window) {
      var t = 0;
      /* Page speed: only react when elements are added (new product cards).
         Text that changes on its own, like the promo bar countdown, used to
         set this off four times a second. */
      new MutationObserver(function (records) {
        var added = false;
        for (var i = 0; i < records.length && !added; i++) {
          var nodes = records[i].addedNodes;
          for (var j = 0; j < nodes.length; j++) { if (nodes[j].nodeType === 1) { added = true; break; } }
        }
        if (!added) return;
        clearTimeout(t); t = setTimeout(function () { decorate(); syncAll(); }, 120);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  /* ======================================================== Menu drawer */
  var root = document.getElementById('HoMenu');
  if (!root) return;
  var panel = root.querySelector('.hom__panel');
  var isOpen = false, pushed = false;

  /* ===================================================== Menu search
     Live results while typing, from Shopify's predictive search (the same
     data as the header search). Enter opens the full results page. */
  var psForm = root.querySelector('.hom__search');
  var psInput = psForm && psForm.querySelector('input[name="q"]');
  var psBox = root.querySelector('[data-hom-ps]');
  var psTimer = 0, psCtrl = null, psLast = '';
  function psEsc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function psMoney(v) {
    var cents = Math.round(parseFloat(v) * 100);
    if (isNaN(cents)) return '';
    try {
      var t = window.theme || {};
      var fmt = (t.settings && t.settings.currency_code_enable && t.moneyWithCurrencyFormat) || t.moneyFormat;
      if (t.formatMoney && fmt) return t.formatMoney(cents, fmt);
    } catch (e) {}
    return (cents / 100).toFixed(2);
  }
  function psImg(u) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120' : ''; }
  function psAllUrl(q) { return psForm.getAttribute('action') + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last'; }
  function psAbort() { if (psCtrl) { try { psCtrl.abort(); } catch (e) {} psCtrl = null; } }
  function psSet(html) {
    var on = html !== '';
    psBox.innerHTML = html;
    psBox.hidden = !on;
    root.classList.toggle('is-searching', on);
    psInput.setAttribute('aria-expanded', on ? 'true' : 'false');
    if (on) psBox.scrollTop = 0;
  }
  function psReset() {
    if (!psBox || !psInput) return;
    clearTimeout(psTimer);
    psAbort();
    psLast = '';
    psInput.value = '';
    psSet('');
  }
  function psRender(q, r) {
    var p = (r.products || []).slice(0, 6), c = (r.collections || []).slice(0, 3), s = (r.queries || []).slice(0, 4);
    var all = '<a class="hom__ps-all" href="' + psEsc(psAllUrl(q)) + '">View all results for “' + psEsc(q) + '”</a>';
    if (!p.length && !c.length && !s.length) {
      psSet('<p class="hom__ps-msg">No results for “' + psEsc(q) + '”. Try another word or browse all designs.</p><a class="hom__ps-all" href="' + HO_MENU_CFG.collectionsUrl + '/shop-all">Browse all designs</a>');
      return;
    }
    var h = '';
    if (s.length) {
      h += '<span class="hom__h">SUGGESTIONS</span><ul class="hom__ps-sug">';
      s.forEach(function (it) { h += '<li><a href="' + psEsc(psAllUrl(it.text)) + '">' + psEsc(it.text) + '</a></li>'; });
      h += '</ul>';
    }
    if (p.length) {
      h += '<span class="hom__h">PRODUCTS</span><ul class="hom__ps-list">';
      p.forEach(function (it) {
        var src = (it.featured_image && it.featured_image.url) || it.image;
        var was = parseFloat(it.compare_at_price_max) > parseFloat(it.price);
        h += '<li><a class="hom__ps-item" href="' + psEsc(it.url) + '">'
          + '<span class="hom__ps-img">' + (src ? '<img src="' + psEsc(psImg(src)) + '" alt="" width="56" height="56" loading="lazy">' : '') + '</span>'
          + '<span class="hom__ps-info"><span class="hom__ps-title">' + psEsc(it.title) + '</span>'
          + '<span class="hom__ps-price">' + (was ? '<s>' + psEsc(psMoney(it.compare_at_price_max)) + '</s>' : '') + psEsc(psMoney(it.price)) + '</span></span></a></li>';
      });
      h += '</ul>';
    }
    if (c.length) {
      h += '<span class="hom__h">COLLECTIONS</span><ul class="hom__ps-cols">';
      c.forEach(function (it) { h += '<li><a href="' + psEsc(it.url) + '">' + psEsc(it.title) + '</a></li>'; });
      h += '</ul>';
    }
    psSet(h + all);
  }
  if (psForm && psInput && psBox && window.fetch) {
    psInput.addEventListener('input', function () {
      var q = psInput.value.trim();
      clearTimeout(psTimer);
      if (q.length < 2) { psLast = ''; psAbort(); psSet(''); return; }
      psTimer = setTimeout(function () {
        if (q === psLast) return;
        psLast = q;
        psAbort();
        psCtrl = window.AbortController ? new AbortController() : null;
        if (psBox.hidden) psSet('<p class="hom__ps-msg">Searching…</p>');
        var base = (window.theme && theme.routes && theme.routes.predictiveSearchUrl) || HO_MENU_CFG.predictiveSearchUrl;
        fetch(base + '.json?q=' + encodeURIComponent(q) + '&resources%5Btype%5D=product,collection,query&resources%5Blimit%5D=6&resources%5Boptions%5D%5Bunavailable_products%5D=last', psCtrl ? { signal: psCtrl.signal } : {})
          .then(function (res) { if (!res.ok) throw new Error('search ' + res.status); return res.json(); })
          .then(function (d) { if (q === psInput.value.trim()) psRender(q, (d.resources && d.resources.results) || {}); })
          .catch(function (e) { if (e && e.name === 'AbortError') return; psLast = ''; if (q === psInput.value.trim()) psSet(''); });
      }, 220);
    });
    /* Enter: leave the drawer's history step first (like the links above),
       then open the results page. */
    psForm.addEventListener('submit', function (e) {
      var q = psInput.value.trim();
      e.preventDefault();
      if (!q) return;
      var url = psAllUrl(q);
      var st = history.state;
      if (!isOpen || !st || !st.hoMenu) { location.href = url; return; }
      var done = false;
      var go = function () { if (done) return; done = true; location.href = url; };
      hist.once = go;
      hist.silence();
      try { history.back(); } catch (x) { go(); }
      setTimeout(go, 600);
    });
  }

  function show(name, back) {
    root.querySelectorAll('[data-hom-view]').forEach(function (v) {
      var on = v.getAttribute('data-hom-view') === name;
      v.hidden = !on;
      v.classList.remove('is-in', 'is-back');
      if (on) { void v.offsetWidth; v.classList.add(back ? 'is-back' : 'is-in'); }
    });
    root.querySelector('.hom__body').scrollTop = 0;
  }
  function open() {
    if (isOpen) return;
    isOpen = true;
    psReset();
    show('main', true);
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('hom-open');
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-on'); }); });
    try { history.pushState({ hoMenu: 1 }, ''); pushed = true; } catch (e) {}
    setTimeout(function () { panel.focus({ preventScroll: true }); }, 60);
  }
  function close(fromHistory) {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-on');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('hom-open');
    setTimeout(function () { if (!isOpen) root.hidden = true; }, 330);
    if (pushed && !fromHistory) { pushed = false; try { hist.silence(); history.back(); } catch (e) {} }
    pushed = false;
  }
  window.HoMenu = { open: open, close: close };

  /* Take over the theme's burger button (caught before the theme sees it). */
  document.addEventListener('click', function (e) {
    var burger = e.target.closest && e.target.closest('.mobile-menu__button--burger, [data-ho-menu-open]');
    if (!burger) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }, true);

  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-hom-close], [data-hom-open], [data-hom-back]');
    if (!t) return;
    if (t.hasAttribute('data-hom-close')) return close();
    if (t.hasAttribute('data-hom-open')) return show(t.getAttribute('data-hom-open'));
    if (t.hasAttribute('data-hom-back')) return show('main', true);
  });
  document.addEventListener('keydown', function (e) { if (isOpen && e.key === 'Escape') close(); });
  hist.on(function () { if (isOpen) { pushed = false; close(true); } });

  /* Swipe left to close. */
  var sx = 0, sy = 0, dx = 0, drag = false;
  panel.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; dx = 0; drag = true; }, { passive: true });
  panel.addEventListener('touchmove', function (e) {
    if (!drag) return;
    dx = e.touches[0].clientX - sx;
    if (Math.abs(e.touches[0].clientY - sy) > Math.abs(dx)) { drag = false; panel.style.transform = ''; return; }
    if (dx < 0) { panel.style.transition = 'none'; panel.style.transform = 'translate3d(' + dx + 'px,0,0)'; }
  }, { passive: true });
  panel.addEventListener('touchend', function () {
    if (!drag) return;
    drag = false;
    panel.style.transition = '';
    panel.style.transform = '';
    if (dx < -90) close();
  });
})();
